/*eslint-disable */
const safeTrack = (id) => {
    if (typeof cntrUpTag !== 'undefined') cntrUpTag.track('cntrData', id);
}

export const landing = {
    tag : () => safeTrack('3370b80838250ad2'),
    floodlight : () => safeTrack('3370b80838250ad2'),
    image: `<img src="https://pixel.sitescout.com/up/3370b80838250ad2?cntr_revenue=%pcost=!;&cntr_transactionId=%pord=!;&u1=%pu1=!;&u2=%pu2=!;&u3=%pu3=!;&u4=%pu4=!;&u5=%pu5=!;&cntr_url=%p~oref=!?" width="1" height="1" style="position: absolute; left: -150px;" />`,
    postback : `https://pixel.sitescout.com/up/3370b80838250ad2?cntr_postbackAuctionId=[POSTBACK_GOES_HERE]`
}

export const packageButton = {
    tag : () => safeTrack('327bc4afab71ec9f'),
    floodlight : () => safeTrack('327bc4afab71ec9f'),
    image: `<img src="https://pixel.sitescout.com/up/327bc4afab71ec9f?cntr_revenue=%pcost=!;&cntr_transactionId=%pord=!;&u1=%pu1=!;&u2=%pu2=!;&u3=%pu3=!;&u4=%pu4=!;&u5=%pu5=!;&cntr_url=%p~oref=!?" width="1" height="1" style="position: absolute; left: -150px;" />`,
    postback : `https://pixel.sitescout.com/up/327bc4afab71ec9f?erp_id=`
}


export const coburtura = {
    tag : () => safeTrack('0aacb6d2ea4a0b31'),
    floodlight : () => safeTrack('0aacb6d2ea4a0b31'),
    image: `<img src="https://pixel.sitescout.com/up/0aacb6d2ea4a0b31?cntr_revenue=%pcost=!;&cntr_transactionId=%pord=!;&u1=%pu1=!;&u2=%pu2=!;&u3=%pu3=!;&u4=%pu4=!;&u5=%pu5=!;&cntr_url=%p~oref=!?" width="1" height="1" style="position: absolute; left: -150px;" />`,
    postback : `https://pixel.sitescout.com/up/0aacb6d2ea4a0b31?cntr_postbackAuctionId=[POSTBACK_GOES_HERE]`
}


export const checkoutStepOne = {
    tag : () => safeTrack('27e37dd86f4f47f4'),
    floodlight : () => safeTrack('27e37dd86f4f47f4'),
    image: `<img src="https://pixel.sitescout.com/up/27e37dd86f4f47f4?cntr_revenue=%pcost=!;&cntr_transactionId=%pord=!;&u1=%pu1=!;&u2=%pu2=!;&u3=%pu3=!;&u4=%pu4=!;&u5=%pu5=!;&cntr_url=%p~oref=!?" width="1" height="1" style="position: absolute; left: -150px;" />`,
    postback : `https://pixel.sitescout.com/up/27e37dd86f4f47f4?cntr_postbackAuctionId=[POSTBACK_GOES_HERE]`
}


export const checkoutStepTwo = {
    tag : () => safeTrack('a12a1085b5bae6ed'),
    floodlight : () => safeTrack('a12a1085b5bae6ed'),
    image: `<img src="https://pixel.sitescout.com/up/a12a1085b5bae6ed?cntr_revenue=%pcost=!;&cntr_transactionId=%pord=!;&u1=%pu1=!;&u2=%pu2=!;&u3=%pu3=!;&u4=%pu4=!;&u5=%pu5=!;&cntr_url=%p~oref=!?" width="1" height="1" style="position: absolute; left: -150px;" />`,
    postback : `https://pixel.sitescout.com/up/a12a1085b5bae6ed?cntr_postbackAuctionId=[POSTBACK_GOES_HERE]`
}


export const checkoutStepThree = {
    tag : () => safeTrack('0ba379288ae87d80'),
    floodlight : () => safeTrack('0ba379288ae87d80'),
    image: `<img src="https://pixel.sitescout.com/up/0ba379288ae87d80?cntr_revenue=%pcost=!;&cntr_transactionId=%pord=!;&u1=%pu1=!;&u2=%pu2=!;&u3=%pu3=!;&u4=%pu4=!;&u5=%pu5=!;&cntr_url=%p~oref=!?" width="1" height="1" style="position: absolute; left: -150px;" />`,
    postback : `https://pixel.sitescout.com/up/0ba379288ae87d80?cntr_postbackAuctionId=[POSTBACK_GOES_HERE]`
}


export const checkoutStepFour = {
    tag : () => safeTrack('70e45e627bf485d0'),
    floodlight : () => safeTrack('70e45e627bf485d0'),
    image: `<img src="https://pixel.sitescout.com/up/70e45e627bf485d0?cntr_revenue=%pcost=!;&cntr_transactionId=%pord=!;&u1=%pu1=!;&u2=%pu2=!;&u3=%pu3=!;&u4=%pu4=!;&u5=%pu5=!;&cntr_url=%p~oref=!?" width="1" height="1" style="position: absolute; left: -150px;" />`,
    postback : `https://pixel.sitescout.com/up/70e45e627bf485d0?cntr_postbackAuctionId=[POSTBACK_GOES_HERE]`
}


export const checkoutStepFive = {
    tag : () => safeTrack('b17c56297e98de16'),
    floodlight : () => safeTrack('b17c56297e98de16'),
    image: `<img src="https://pixel.sitescout.com/up/b17c56297e98de16?cntr_revenue=%pcost=!;&cntr_transactionId=%pord=!;&u1=%pu1=!;&u2=%pu2=!;&u3=%pu3=!;&u4=%pu4=!;&u5=%pu5=!;&cntr_url=%p~oref=!?" width="1" height="1" style="position: absolute; left: -150px;" />`,
    postback : `https://pixel.sitescout.com/up/b17c56297e98de16?cntr_postbackAuctionId=[POSTBACK_GOES_HERE]`
}

export const checkoutStepSix = {
    tag : () => safeTrack('f34393a814681d08'),
    floodlight : () => safeTrack('f34393a814681d08'),
    image: `<img src="https://pixel.sitescout.com/up/f34393a814681d08?cntr_revenue=%pcost=!;&cntr_transactionId=%pord=!;&u1=%pu1=!;&u2=%pu2=!;&u3=%pu3=!;&u4=%pu4=!;&u5=%pu5=!;&cntr_url=%p~oref=!?" width="1" height="1" style="position: absolute; left: -150px;" />`,
    postback : `https://pixel.sitescout.com/up/f34393a814681d08?cntr_postbackAuctionId=[POSTBACK_GOES_HERE]`
}

export const pagar = {
    tag : () => safeTrack('4fac08b46b727154'),
    floodlight : () => safeTrack('4fac08b46b727154'),
    image: `<img src="https://pixel.sitescout.com/up/4fac08b46b727154?cntr_revenue=%pcost=!;&cntr_transactionId=%pord=!;&u1=%pu1=!;&u2=%pu2=!;&u3=%pu3=!;&u4=%pu4=!;&u5=%pu5=!;&cntr_url=%p~oref=!?" width="1" height="1" style="position: absolute; left: -150px;" />`,
    postback : `https://pixel.sitescout.com/up/4fac08b46b727154?cntr_postbackAuctionId=[POSTBACK_GOES_HERE]`
}

export const success = {
    tag : () => safeTrack('f3607b205dd0e6aa'),
    floodlight : () => safeTrack('f3607b205dd0e6aa'),
    image: `<img src="https://pixel.sitescout.com/up/f3607b205dd0e6aa?cntr_revenue=%pcost=!;&cntr_transactionId=%pord=!;&u1=%pu1=!;&u2=%pu2=!;&u3=%pu3=!;&u4=%pu4=!;&u5=%pu5=!;&cntr_url=%p~oref=!?" width="1" height="1" style="position: absolute; left: -150px;" />`,
    postback : `https://pixel.sitescout.com/up/f3607b205dd0e6aa?cntr_postbackAuctionId=[POSTBACK_GOES_HERE]`
}

export const pagoEffectivo = {
    tag : () => safeTrack('f2b97f3f1b45fe6b'),
    floodlight : () => safeTrack('f2b97f3f1b45fe6b'),
    image: `<img src="https://pixel.sitescout.com/up/f2b97f3f1b45fe6b?cntr_revenue=%pcost=!;&cntr_transactionId=%pord=!;&u1=%pu1=!;&u2=%pu2=!;&u3=%pu3=!;&u4=%pu4=!;&u5=%pu5=!;&cntr_url=%p~oref=!?" width="1" height="1" style="position: absolute; left: -150px;" />`,
    postback : `https://pixel.sitescout.com/up/f2b97f3f1b45fe6b?cntr_postbackAuctionId=[POSTBACK_GOES_HERE]`
}

